
export const GPS = ({size}) =>{

    return(
        <svg xmlns="http://www.w3.org/2000/svg" style={{}} width={size||"26"} height={size||"26"} viewBox="0 0 46 46" fill="none">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M6.70801 19.7757C6.70801 10.9593 14.0754 3.83333 22.9871 3.83333C31.9239 3.83333 39.2913 10.9593 39.2913 19.7757C39.2913 24.2184 37.6756 28.3429 35.0162 31.8388C32.0824 35.6951 28.4663 39.0549 24.396 41.6921C23.4645 42.3016 22.6238 42.3476 21.6014 41.6921C17.5079 39.0549 13.8918 35.6951 10.9831 31.8388C8.32181 28.3429 6.70801 24.2184 6.70801 19.7757ZM17.6219 20.2721C17.6219 23.2256 20.032 25.5485 22.9871 25.5485C25.9441 25.5485 28.3774 23.2256 28.3774 20.2721C28.3774 17.3416 25.9441 14.9056 22.9871 14.9056C20.032 14.9056 17.6219 17.3416 17.6219 20.2721Z" fill="#6F4A96"/>
                        </svg>
    )
}
